import React, {Component} from 'react';
import {Row, Col, FormGroup, FormControl, Glyphicon, ButtonToolbar, Button} from 'react-bootstrap';
import FieldGroup from '../../../camposTexto/FieldGroup';
import axios from 'axios';
import c from '../../../Constants';

//Images
import cargando from '../../../assets/img/cargando.gif';
import wasap from '../../../assets/img/wasap.png';
import ig from '../../../assets/img/instagram.png';
import face from '../../../assets/img/facebook.png';
//CSS
import '../LandingSubcomponents/Contacto.css';

class Contacto extends Component {

    constructor() {
        super();
        this.state = {nombre: "", mail: "", telefono: "", mensaje: "", ok: "", error: "", enviando: "false"};
    }

    changeMail(evento) {
        var cambio = {};
        cambio[evento.target.id] = evento.target.value;
        this.setState(cambio);
    }

    enviarConsulta(evento) {
        // console.log(evento);
        evento.preventDefault();
        this.setState({enviando: true});
        axios.post(c.BASE_URL + '/api/mail', {
            nombre: this.state.nombre,
            mail: this.state.mail,
            telefono: this.state.telefono,
            mensaje: this.state.mensaje
        })
            .then(res => {
                // console.log(res);
                this.setState({ok: res.data.message, enviando: false});
            })
            .catch((error) => {
                // console.log(error);
                this.setState({error: error.response.data.message, enviando: false});
            });
    }


    render() {

        var {nombre, mail, telefono, mensaje, error, ok} = this.state;

        return (
            <div id="contacto">
                <Row className="contacto-titulo">
                    <h3>
                        Contactanos
                    </h3>
                </Row>
                <Row className="contacto">
                    <Col md={6} sm={12} xs={12} className="contacto-seccion-izquierda">
                        <div className="logo wow animate fadeInLeft" data-wow-duration=".5s" data-wow-delay=".1s">
                            {/*<img src={logo} className="img-responsive" alt="myf-distribuciones"/>*/}
                            <h5>¡Respondemos todas tus dudas! Dejanos un mensaje en el <b>formulario de
                                contacto</b> o <b>comunicate</b> con nosotros a través de los siguiente medios.</h5>
                        </div>
                        <div className="informacion wow animate fadeInLeft"
                             data-wow-duration=".5s" data-wow-delay=".3s">
                            <Glyphicon style={{color: "black", marginTop: "20px", marginBottom: "20px"}} glyph="send"/>
                            <p>info@myfdistribuciones.com.ar</p>
                            <Glyphicon style={{color: "black", marginTop: "20px", marginBottom: "20px"}}
                                       glyph="earphone"/>
                            <p>(0341) 243 1648 | 239 7645 | 240 4545</p>
                            <img src={wasap}
                                 style={{color: "black", marginTop: "20px", marginBottom: "20px", maxWidth: "17px"}}
                                 alt=""/>
                            <p>+54 (341) 2153690</p>
                            <Glyphicon style={{color: "black", marginTop: "20px", marginBottom: "20px"}} glyph="globe"/>
                            <p>Rosario, Sante Fe, Argentina</p>
                            <div className="redes">
                                <a href="https://www.facebook.com/myfdistribucioness" target="_blank" >
                                    <img src={face} alt="Facebook"/>
                                </a>
                                <a href="https://www.instagram.com/myfdistribuciones/" target="_blank">
                                    <img src={ig} alt=""/>
                                </a>
                            </div>
                        </div>
                    </Col>
                    <Col md={6} sm={12} xs={12} className="contacto-seccion-derecha">
                        <div className="formulario center-block">
                            <form onSubmit={(e) => this.enviarConsulta(e)}>
                                <FieldGroup
                                    className="wow animate fadeInRight"
                                    data-wow-duration=".5s" data-wow-delay=".5s"
                                    id="nombre"
                                    type="text"
                                    placeholder="Nombre"
                                    disabled={false}
                                    value={nombre}
                                    onChange={(e) => this.changeMail(e)}
                                    required={true}
                                />
                                <FieldGroup
                                    className="wow animate fadeInRight"
                                    data-wow-duration=".5s" data-wow-delay=".65s"
                                    id="mail"
                                    type="email"
                                    placeholder="E-mail"
                                    disabled={false}
                                    value={mail}
                                    onChange={(e) => this.changeMail(e)}
                                    required={true}
                                />
                                <FieldGroup
                                    className="wow animate fadeInRight"
                                    data-wow-duration=".5s" data-wow-delay=".8s"
                                    id="telefono"
                                    type="text"
                                    placeholder="Teléfono"
                                    disabled={false}
                                    value={telefono}
                                    onChange={(e) => this.changeMail(e)}
                                    required={true}
                                />
                                <FormGroup controlId="mensaje"
                                           className="wow animate fadeInRight"
                                           data-wow-duration=".5s" data-wow-delay=".95s"
                                >
                                    <FormControl componentClass="textarea"
                                                 placeholder="Mensaje"
                                                 style={{height: '200px'}}
                                                 value={mensaje}
                                                 onChange={(e) => this.changeMail(e)}
                                                 required={true}
                                    />
                                </FormGroup>
                                <ButtonToolbar className="wow animate fadeInRight"
                                               data-wow-duration=".5s" data-wow-delay="1.1s"
                                >
                                    <Button className="btn-block btn-lg" type="submit" bsStyle="danger"
                                            disabled={ok != ""}
                                            style={{
                                                display: this.state.enviando != true ? "block" : "none",
                                                marginBottom: "15px", float: "left"
                                            }}>
                                        ENVIAR
                                    </Button>
                                </ButtonToolbar>
                                <img src={cargando} alt="" className="center-block" height={30} width={30}
                                     style={{
                                         display: this.state.enviando == true ? "block" : "none",
                                         marginBottom: "20px"
                                     }}/>
                                <div className="mail-enviado" style={{display: ok != "" ? "block" : "none"}}>
                                    <p>
                                        {ok}
                                    </p>
                                </div>
                                <div className="mail-error" style={{display: error != "" ? "block" : "none"}}>
                                    <p>
                                        {error}
                                    </p>
                                </div>
                            </form>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}


export default Contacto;


// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingSubcomponents/Contacto.js